import Compare16 from '@carbon/icons-react/es/compare/16';
import { Dropdown } from 'antd';
import styled from 'styled-components';

export const AnnotationVersionListWrapper = styled.div`
  padding-left: var(--spacing-05);
  padding-right: var(--spacing-06);
`;

export const AnnotationVersionWrapper = styled.div<{ isDeleted: string }>`
  margin: var(--spacing-03) 0;
  width: 100%;
  cursor: ${({ isDeleted }) => (isDeleted === 'false' ? 'pointer' : 'default')};
`;

export const MoreActionsDropdownWrapper = styled(Dropdown)`
  opacity: 0;
  transition: opacity var(--animation-duration-fast) ease-in;
  position: absolute;
  top: var(--spacing-02);
  right: var(--spacing-02);
  background: rgba(22, 22, 22, 0.1);
  width: 22px;
  min-width: 22px;
  height: 22px;
  background: white;
`;

export const VersionImage = styled.div<{ isSelectedVersion: boolean }>`
  border: ${({ isSelectedVersion }) =>
    isSelectedVersion
      ? '2px solid var(--blue-60)'
      : '1px solid var(--gray-20)'};
  width: 100%;
  height: 83px;
  position: relative;

  ${MoreActionsDropdownWrapper}:focus-within {
    opacity: 1;
  }

  &:hover,
  &:active {
    ${MoreActionsDropdownWrapper} {
      opacity: 1;
    }
  }
`;

export const Image = styled.img`
  height: 100%;
  width: 100%;
  object-fit: contain;
`;

export const VersionDetail = styled.div`
  margin: var(--spacing-03) 0;
`;

export const VersionName = styled.div<{ isSelectedVersion: boolean }>`
  color: ${({ isSelectedVersion }) =>
    isSelectedVersion ? 'var(--gray-80)' : 'var(--gray-50)'};
  font-weight: var(--heading-4-weight);
  font-size: 14px;
  line-height: 18px;
`;

export const VersionTime = styled.div<{ isSelectedVersion: boolean }>`
  color: ${({ isSelectedVersion }) =>
    isSelectedVersion ? 'var(--gray-50)' : 'var(--gray-30)'};
  font-weight: var(--heading-4-weight);
  font-size: var(--spacing-04);
  line-height: var(--spacing-05);
`;

export const TrailBar = styled.div`
  min-height: 30px;
  height: 30px;
  border-left: 1px solid var(--gray-20);
`;

export const CompareIcon = styled(Compare16)`
  margin-right: var(--spacing-03);
`;
